module.exports = "/img/_/_/_/assets/images/creeper/battle/common//30.jpg?f748c5e4fa3ed82128bebd08db7e7e7a";